import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Heading,
  ModalHeader,
  ModalCloseButton,
  ModalFooter,
} from '@chakra-ui/react';
import { useProfile } from '@partiu/ui/contexts/ProfileProvider';
import { Button } from '../atoms/Button';
import { useTheme } from '../../contexts/ThemeProvider';
import { useNavigate } from 'react-router-dom';

export function ModalLoginAndPlan({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
  const { profile } = useProfile();
  const { id, colors } = useTheme();

  const navigation = useNavigate();

  return (
    <Modal onClose={onClose} isCentered isOpen={isOpen}>
      <ModalOverlay />
      <ModalContent margin={'20px'} borderRadius={'16px'}>
        <ModalHeader>{!profile ? 'Faça o Login' : 'Contrate um plano'}</ModalHeader>
        <ModalCloseButton color={colors.primaryColor} />

        <ModalBody padding="20px">
          <Heading color="#747474" fontFamily={'Glory'} fontWeight="400" fontSize={18}>
            {!profile
              ? 'Olá, notamos que você ainda não está logado. Faça o login para continuar.'
              : 'Olá, notamos você ainda não possui um plano ativo. Contrate um plano para continuar.'}
          </Heading>
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={() => {
              !profile
                ? navigation('/login')
                : navigation(`/perfil/planos`);
              onClose();
            }}
            variant="ghost"
          >
            {!profile ? 'Fazer Login' : 'Contratar'}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
